(function(){
  // announcement bar: auto-slide (needs 2+ announcements)
  document.querySelectorAll('[data-slider]').forEach(function(el){
    var items=el.querySelectorAll('.announcement__item'),len=items.length,i=0,t;
    var nextBtn=el.querySelector('[data-next]'),prevBtn=el.querySelector('[data-prev]');
    if(len<2){if(nextBtn)nextBtn.style.visibility='hidden';if(prevBtn)prevBtn.style.visibility='hidden';return}
    function show(n,back){
      var out=items[i],nx=items[(n+len)%len];
      if(out===nx)return;
      items.forEach(function(it){if(it!==out&&it!==nx)it.classList.remove('is-active','is-prev')});
      nx.style.transition='none';
      if(back){nx.classList.add('is-prev')}else{nx.classList.remove('is-prev')}
      void nx.offsetWidth;
      nx.style.transition='';
      nx.classList.remove('is-prev');
      nx.classList.add('is-active');
      out.classList.remove('is-active');
      if(!back)out.classList.add('is-prev');
      i=(n+len)%len;
    }
    function auto(){clearInterval(t);t=setInterval(function(){show(i+1,false)},3500)}
    if(nextBtn)nextBtn.addEventListener('click',function(){show(i+1,false);auto()});
    if(prevBtn)prevBtn.addEventListener('click',function(){show(i-1,true);auto()});
    var sx=0;
    el.addEventListener('touchstart',function(e){sx=e.touches[0].clientX},{passive:true});
    el.addEventListener('touchend',function(e){var dx=e.changedTouches[0].clientX-sx;if(Math.abs(dx)>40){dx<0?show(i+1,false):show(i-1,true);auto()}},{passive:true});
    auto();
  });
  // menu drawer
  var drawer=document.querySelector('[data-drawer]');
  if(drawer){
    document.querySelectorAll('[data-menu-open]').forEach(function(b){b.addEventListener('click',function(){drawer.hidden=false;document.body.style.overflow='hidden'})});
    document.querySelectorAll('[data-menu-close]').forEach(function(b){b.addEventListener('click',function(){drawer.hidden=true;document.body.style.overflow=''})});
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!drawer.hidden){drawer.hidden=true;document.body.style.overflow=''}});
  }
  // scroller progress bar (shop the look)
  document.querySelectorAll('.shop-look').forEach(function(sec){
    var track=sec.querySelector('[data-scroller]'),bar=sec.querySelector('[data-scrollbar] span');
    if(!track||!bar)return;
    function upd(){var max=track.scrollWidth-track.clientWidth;var ratio=track.clientWidth/track.scrollWidth;bar.style.width=Math.max(ratio*100,15)+'%';bar.style.left=(max>0?(track.scrollLeft/max)*(100-parseFloat(bar.style.width)):0)+'%'}
    track.addEventListener('scroll',upd,{passive:true});window.addEventListener('resize',upd);upd();
  });
  // product recommendations (Frequently Bought With)
  document.querySelectorAll('[data-recs]').forEach(function(sec){
    var url=sec.getAttribute('data-url');
    if(!url)return;
    fetch(url).then(function(r){return r.text()}).then(function(txt){
      var doc=new DOMParser().parseFromString(txt,'text/html');
      var n=doc.querySelector('[data-recs]');
      if(n&&n.querySelector('.pcard')){sec.innerHTML=n.innerHTML}
    }).catch(function(){});
  });
})();
